export const THERAPY_LISTING_COLUMNS = ['Client Name', 'Note Type', 'Amendment Date']
export const THERAPY_SORTING_COLUMNS = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
  'Amendment Date': 'dateOfAmendment'
}
export const THERAPY_COLUMNS_DATA_MAPPING = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
  'Amendment Date': 'dateOfAmendment'
}

export const THERAPY_ENTRIES_COLUMNS = ['Begin Date', 'End Date']
export const THERAPY_ENTRIES_SORTING_COLUMNS = {
  'Begin Date': 'startDate',
  'End Date': 'endDate',
}
export const THERAPY_ENTRIES_COLUMNS_DATA_MAPPING = {
  'Begin Date': 'startDate',
  'End Date': 'endDate',
}
